export const STATES = [
    "PENDIENTE",
    "EN ESPERA",
    "RECHAZADO",
    "AUTORIZADO"
];

export const ifState = (state) => {
    if(state== "PENDIENTE"){
        return ["EN ESPERA", "AUTORIZADO", "RECHAZADO"];
    }else if(state== "EN ESPERA"){
        return ["AUTORIZADO", "RECHAZADO"];
    }else if(state== "RECHAZADO"){
        return [];
    }else if(state== "AUTORIZADO"){
        return [];
    }
    return [];
}